import React from 'react';
import { Table } from 'rsuite';
import { exists } from '../../../../../common/utilities/utilitiesFunctions';
import { translate } from 'react-i18next';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import "rsuite/dist/rsuite.min.css";
const { Column, HeaderCell, Cell } = Table;

const WorkplanQuotaTable = ({
    classes,
    selectedWorkPlan,
    displayQuota,
    columns,
    height,
    ...props
}) => {
    let defaultQuotasData = [];
    if (displayQuota && exists(selectedWorkPlan.quotas)) {
        defaultQuotasData = [...selectedWorkPlan.quotas];
    }
    const ShiftTemplateCell = React.memo(({ rowData, column, dataKey, ...props }) => {

        return (
            <Cell className={`${column.className || ''} table-cell`} dataKey={column.field} {...props}>{column.render(rowData)}</Cell>
        );
    });

    return (
        displayQuota && exists(selectedWorkPlan.quotas) ?
            <div className={classes.tableContainer}>
                <hr style={{ height: '5px', backgroundColor: 'black' }}></hr>
                <Table
                    isTree
                    style={{ margin: "0 20px" }}
                    data={defaultQuotasData}
                    rowKey="id"
                    affixHorizontalScrollbar
                    rowHeight={60}
                    bordered={true}
                    height={height - 150}
                    shouldUpdateScroll={false}
                    renderTreeToggle={(icon, rowData, expanded) => {
                        if (rowData.children && rowData.children.length === 0) {
                            return <></>;
                        }
                        return expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />
                    }}
                >
                    {columns.filter(x => exists(x.field) && (x.field.includes("day") || x.field === 'orgPath' || x.field === 'emptyColumn')).map((column) => (
                        <Column
                            minWidth={column.minWidth}
                            flexGrow={column.flexGrow}
                            key={column.field}
                        >
                            <HeaderCell>{column.title}</HeaderCell>
                            {
                                exists(column.field) && column.field.includes("day") ?
                                    <ShiftTemplateCell column={column} className={column.className} field={column.field} render={column.render} /> :
                                    <Cell className={`${column.className || ''} table-cell`} dataKey={column.field}>{column.render}</Cell>
                            }
                        </Column>
                    ))}
                </Table>
            </div> : <div></div>
    );
}

export default translate('workplanManager')(WorkplanQuotaTable);